import { mergeOptions } from '@tencent/halo-utils';

export interface IOptions {
  head: {
    userInfo: {
      guid?: string;
      qimei?: string;
      imei?: string;
      uuid?: string;
      evilScore?: number;
    };
    [key: string]: any;
  };
  listS?: {
    [key: string]: (string | undefined)[] | undefined;
  };
  listI?: {
    [key: string]: (Number | undefined)[] | undefined;
  };
  /** 请求Source */
  param?: string;
  /** 请求Operate */
  OperateId?: string;
  queue?: string;
}

const BaseOperateRequestData = {
  head: {
    cmd: 'syzsoperate', // 命令字 也就是对外接口名 接入层唯一标识符
    userInfo: {
      guid: '',
    },
    authInfo: {
      businessId: 'AuthName', // 接入标识
    },
    hostAppInfo: {
      scene: '',
    },
  },
  body: {
    Bid: 'syzs',
    OperateId: '',
    num: 0,
    param: '',
    listS: {},
    listI: {},
  },
};

/**
 * 请求手助的接入层服务
 * @param options 接入层请求参数
 */
export const sourceAjax = async (options: IOptions) => {
  const { head = {}, listS = {}, listI = {}, param, OperateId } = options;

  const requestData = mergeOptions.call({}, BaseOperateRequestData, {
    head,
    body: {
      Bid: 'syzsoversea',
      listS,
      listI,
      param,
      OperateId,
    },
  });

  const url = param
    ? `//unifiedaccess.gameloop.com/v2/syzssource?params=${encodeURIComponent(param)}`
    : '//unifiedaccess.gameloop.com/v2/syzsoperate';

  const result = await fetch(url, {
    method: 'post',
    body: JSON.stringify(requestData),
  });

  return result;
};
